import { forwardRef } from "react";
import { segmentVariants } from "./styles";
import { VariantProps } from "class-variance-authority";
import { cn } from "../..";

export interface SegmentProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children">,
    VariantProps<typeof segmentVariants> {
  value: string | number;
  unit: string;
}

export const Segment = forwardRef<HTMLDivElement, SegmentProps>(({ className, status, value, unit, ...props }, ref) => {
  return (
    <div ref={ref} className={cn(segmentVariants({ status }), className)} {...props}>
      <span className="text-xs font-medium leading-none">{value}</span>
      <span className="text-[10px] leading-none mt-0.5">{unit}</span>
    </div>
  );
});
